import { beAsyncTaskGetTaskDetails } from 'Api/beAsyncTaskApi'
import {
  beAutomationApiCheckCanCreate,
  beAutomationApiCopyWorkflow,
  beAutomationApiDeleteWorkflow,
  beAutomationApiGetWorkflowsList,
  beAutomationApiSetEnableWorkflow,
  beAutomationApiSimulateWorkflow
} from 'Api/beAutomationApi'
import { beAutomationApiGetAutomationWorkflow } from 'Api/beAutomationApiTS'
import {
  beListApiGetAllTags,
  beListGetStatusOfWelcomeMessage
} from 'Api/beListApi'
import { beMessApiGetMessagesList } from 'Api/beMessApi'
import { INPUT_MESSAGES_MAX_ITEMS } from 'Constants'
import { STORE_KEY_ID_LIST } from 'Constants/'
import { storeGet } from 'Helpers/localStorage'

export async function checkCanCreate() {
  const result = await beAutomationApiCheckCanCreate()
  return result
}

export async function getWorkflowsList(params, bodyParams) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beAutomationApiGetWorkflowsList(idList, params, bodyParams)
  return result
}

export const getWorkflow = beAutomationApiGetAutomationWorkflow

export async function setEnableWorkflow(idWorkflow, params) {
  const result = beAutomationApiSetEnableWorkflow(idWorkflow, params)
  return result
}

export async function copyWorkflow(idWorkflow) {
  const result = beAutomationApiCopyWorkflow(idWorkflow)
  return result
}

export async function simulateWorkflow(idWorkflow) {
  const result = beAutomationApiSimulateWorkflow(idWorkflow)
  return result
}

export async function deleteWorkflow(idWorkflow) {
  const result = beAutomationApiDeleteWorkflow(idWorkflow)
  return result
}

export async function simulateAsync(idTask) {
  const result = beAsyncTaskGetTaskDetails(idTask)
  return result
}

export async function getMessagesList(searchString) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  let filterBy
  if (searchString) {
    filterBy = !isNaN(searchString)
      ? `Subject.Contains('${searchString}') || Id==${searchString}`
      : `Subject.Contains('${searchString}')`
  }
  const { Items, TotalItems } = await beMessApiGetMessagesList(idList, {
    filterBy,
    pageSize: INPUT_MESSAGES_MAX_ITEMS
  })

  return {
    count: TotalItems,
    items: Items.map(({ Id: id, Subject: subject }) => ({ id, subject }))
  }
}

export async function getStatusOfWelcomeMessage() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beListGetStatusOfWelcomeMessage(idList)
  return result
}

export async function getTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const { Items } = await beListApiGetAllTags(idList, true, false)

  return Items.map((t) => ({
    label: t.Name,
    value: t.Id
  }))
}
